import { doLogout } from "actions/authAction";
import {
  BASE_URL,
  ROUTE_URL,
  ROUTE_GET_ERROR,
  ROUTE_GET_LOADING,
  ROUTE_GET_SUCCESS,
  ROUTE_VIEW_ERROR,
  ROUTE_VIEW_LOADING,
  ROUTE_VIEW_SUCCESS,
  ROUTE_ADD_ERROR,
  ROUTE_ADD_LOADING,
  ROUTE_ADD_SUCCESS,
  ROUTE_DELETE_ERROR,
  ROUTE_DELETE_LOADING,
  ROUTE_DELETE_SUCCESS,
  ROUTE_LIST_SHIPPER_ERROR,
  ROUTE_LIST_SHIPPER_LOADING,
  ROUTE_LIST_SHIPPER_SUCCESS,
  ROUTE_GET_PERCENTAGE_SUCCESS,
  ROUTE_GET_PERCENTAGE_ERROR,
  ROUTE_GET_PERCENTAGE_LOADING,
  ROUTE_ADd_PERCENTAGE_SUCCESS,
  ROUTE_ADD_PERCENTAGE_SUCCESS,
  ROUTE_ADD_PERCENTAGE_ERROR,
  ROUTE_ADD_PERCENTAGE_LOADING,
  ROUTE_PERCENTAGE_URL,
  ROUTE_PERCENTAGE_ADD_URL,
} from "./constant";
export const ROUTE_ADD_ERROR_MESSAGE = "ROUTE_ADD_ERROR_MESSAGE";
const routeGetError = (bool) => {
  return {
    type: ROUTE_GET_ERROR,
    routeGetError: bool,
  };
};

const routeGetLoading = (bool) => {
  return {
    type: ROUTE_GET_LOADING,
    routeGetLoading: bool,
  };
};

const routeGetSuccess = (bool, routes) => {
  return {
    type: ROUTE_GET_SUCCESS,
    routeGetSuccess: bool,
    routes,
  };
};

const routeGetPercentageSuccess = (bool, routePercentage) => {
  return {
    type: ROUTE_GET_PERCENTAGE_SUCCESS,
    routeGetPercentageSuccess: bool,
    routePercentage,
  };
};

const routeGetPercentageError = (bool) => {
  return {
    type: ROUTE_GET_PERCENTAGE_ERROR,
    routeGetPercentageError: bool,
  };
};

const routeGetPercentageLoading = (bool) => {
  return {
    type: ROUTE_GET_PERCENTAGE_LOADING,
    routeGetPercentageLoading: bool,
  };
};

const routeAddPercentageSuccess = (bool, routes) => {
  return {
    type: ROUTE_ADD_PERCENTAGE_SUCCESS,
    routeAddPercentageSuccess: bool,
    routes,
  };
};

const routeAddPercentageError = (bool) => {
  return {
    type: ROUTE_ADD_PERCENTAGE_ERROR,
    routeAddPercentageError: bool,
  };
};

const routeAddPercentageLoading = (bool) => {
  return {
    type: ROUTE_ADD_PERCENTAGE_LOADING,
    routeAddPercentageLoading: bool,
  };
};

const routeViewError = (bool) => {
  return {
    type: ROUTE_VIEW_ERROR,
    routeViewError: bool,
  };
};

const routeViewLoading = (bool) => {
  return {
    type: ROUTE_VIEW_LOADING,
    routeViewLoading: bool,
  };
};

const routeViewSuccess = (bool, route) => {
  return {
    type: ROUTE_VIEW_SUCCESS,
    routeViewSuccess: bool,
    route,
  };
};

const routeAddError = (bool) => {
  return {
    type: ROUTE_ADD_ERROR,
    routeAddError: bool,
  };
};
const routeAddErrorMsgs = (msg) => {
  return {
    type: ROUTE_ADD_ERROR_MESSAGE,
    routeAddErrorMsg: msg,
  };
};

const routeAddLoading = (bool) => {
  return {
    type: ROUTE_ADD_LOADING,
    routeAddLoading: bool,
  };
};

const routeAddSuccess = (bool, route) => {
  return {
    type: ROUTE_ADD_SUCCESS,
    routeAddSuccess: bool,
    route,
  };
};

const routeDeleteError = (bool) => {
  return {
    type: ROUTE_DELETE_ERROR,
    routeDeleteError: bool,
  };
};

const routeDeleteLoading = (bool) => {
  return {
    type: ROUTE_DELETE_LOADING,
    routeDeleteLoading: bool,
  };
};

const routeDeleteSuccess = (bool, route) => {
  return {
    type: ROUTE_DELETE_SUCCESS,
    routeDeleteSuccess: bool,
    route,
  };
};

const routeListShipperLoading = (bool) => {
  return {
    type: ROUTE_LIST_SHIPPER_LOADING,
    routeListShipperLoading: bool,
  };
};

const routeListShipperSuccess = (bool, routeList) => {
  return {
    type: ROUTE_LIST_SHIPPER_SUCCESS,
    routeListShipperSuccess: bool,
    routeList,
  };
};

const routeListShipperError = (bool) => {
  return {
    type: ROUTE_LIST_SHIPPER_ERROR,
    routeListShipperError: bool,
  };
};

export function routeListShipper(params) {
  return (dispatch) => {
    dispatch(routeListShipperSuccess(false, null));
    dispatch(routeListShipperError(false));
    dispatch(routeListShipperLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL + "/list", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeListShipperLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeListShipperSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeListShipperError(true));
      });
  };
}

export function routeFetchAll() {
  return (dispatch) => {
    dispatch(routeAddSuccess(false, null));
    dispatch(routeGetSuccess(false, null));
    dispatch(routeGetError(false));
    dispatch(routeGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeGetSuccess(true, data));
        dispatch(routeGetLoading(false));
      })
      .catch((err) => {
        dispatch(routeGetError(true));
        dispatch(routeGetLoading(false));
      });
  };
}

export function routeFetchSub(path) {
  return (dispatch) => {
    dispatch(routeAddSuccess(false, null));
    dispatch(routeGetSuccess(false, null));
    dispatch(routeGetError(false));
    dispatch(routeGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }

    fetch(BASE_URL + ROUTE_URL + "/" + path, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeGetError(true));
      });
  };
}

export function routeReset() {
  return (dispatch) => {
    dispatch(routeGetSuccess(false, null));
  };
}

export function routeFetchPercentagePage(params) {
  return (dispatch) => {
    dispatch(routeAddPercentageSuccess(false, null));
    dispatch(routeGetPercentageSuccess(false, null));
    dispatch(routeGetPercentageError(false));
    dispatch(routeGetPercentageLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_PERCENTAGE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeGetPercentageLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeGetPercentageSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeGetPercentageError(true));
      });
  };
}

export function routePercentageAdd(data) {
  return (dispatch) => {
    dispatch(routeAddPercentageLoading(true));
    dispatch(routeAddPercentageError(false));
    // dispatch(routeAddPercentageErrorMsgs(''))
    dispatch(routeAddPercentageSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + ROUTE_PERCENTAGE_ADD_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeAddPercentageLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((route) => {
        if (route.status === 200) {
          dispatch(routeAddPercentageSuccess(true, route));
        } else {
          dispatch(routeAddPercentageError(true));
          // dispatch(routeAddPercentageErrorMsgs(route.message));
        }
      })
      .catch((err) => {
        dispatch(routeAddPercentageError(true));
        // dispatch(routeAddPercentageErrorMsgs('Something when wrong, Please try again'))
      });
  };
}

export function routeFetchPage(params) {
  return (dispatch) => {
    dispatch(routeAddSuccess(false, null));
    dispatch(routeGetSuccess(false, null));
    dispatch(routeGetError(false));
    dispatch(routeGetLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL + "/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeGetLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeGetError(true));
      });
  };
}

export function routeAdd(data) {
  return (dispatch) => {
    dispatch(routeAddLoading(true));
    dispatch(routeAddError(false));
    dispatch(routeAddErrorMsgs(""));
    dispatch(routeAddSuccess(false, null));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};

    config = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(BASE_URL + ROUTE_URL, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((route) => {
        if (route.success) {
          dispatch(routeAddSuccess(true, route));
        } else {
          dispatch(routeAddError(true));
          dispatch(routeAddErrorMsgs(route.message));
        }
      })
      .catch((error) => {
        dispatch(routeAddError(true));
        dispatch(routeAddErrorMsgs("Something when wrong, Please try again"));
      });
  };
}

export function routeFetchOne(id) {
  return (dispatch) => {
    dispatch(routeAddSuccess(false, null));
    dispatch(routeViewError(false));
    dispatch(routeViewSuccess(false, null));
    dispatch(routeViewLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL + "/" + id, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeViewLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeViewSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeViewError(true));
      });
  };
}

export function routeUpdate(data) {
  return (dispatch) => {
    dispatch(routeAddError(false));
    dispatch(routeAddSuccess(false, null));
    dispatch(routeAddErrorMsgs(""));
    dispatch(routeAddLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeAddLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((route) => {
        if (route.success) {
          dispatch(routeAddSuccess(true, route));
        } else {
          dispatch(routeAddError(true));
          dispatch(routeAddErrorMsgs(route.message));
        }
      })
      .catch((err) => {
        dispatch(routeAddError(true));
        dispatch(routeAddErrorMsgs("Something when wrong, Please try again"));
      });
  };
}

export function routeDelete(dataPost) {
  return (dispatch) => {
    dispatch(routeViewSuccess(false, null));
    dispatch(routeDeleteError(false));
    dispatch(routeDeleteSuccess(false, null));
    dispatch(routeDeleteLoading(true));

    let token = localStorage.getItem("tolaut@token") || null;
    let config = {};
    if (token) {
      config = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataPost),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + ROUTE_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(routeDeleteLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(routeDeleteSuccess(true, data));
      })
      .catch((err) => {
        dispatch(routeDeleteError(true));
      });
  };
}
